module.exports = __webpack_public_path__ + "static/merck-logo-29f150cc902ecd9c86f61ad8dde2182a.png";